export default function({cellData}) {
  return cellData === undefined || cellData === null ? '' : cellData.toString();
}
